import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'unauthorized',
  styleUrls: ['../../../assets/auth/auth.scss'],
  templateUrl: './unauthorized.component.html',
  styles: [
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnauthorizedComponent implements OnInit {

  constructor(
    private readonly _authService: AuthService,
  ) { }

  ngOnInit(): void {
  }

  public confirmSignOut() {
    this._authService.logout();
  }

}
